import * as R from 'remeda';
import { z } from 'zod';

export const calendlyLinks = {
  dc: 'https://calendly.com/d/cw66-6xq-m52/rossum-product-discovery',
  pat: 'https://calendly.com/d/cv43-vcf-jx2/rossum-product-feedback-discovery-call',
  integration: 'https://calendly.com/d/csnj-c7c-qn7/meet-rossum-product-team',
} as const satisfies Record<CalendlyLinkVariantSchema, string>;

export const calendlyLinkVariants = R.keys(calendlyLinks);

export const calendlyLinkVariantSchema = z.union([
  z.literal('dc'),
  z.literal('pat'),
  z.literal('integration'),
]);

type CalendlyLinkVariantSchema = z.infer<typeof calendlyLinkVariantSchema>;
